<!-- <label class="text-danger mt-40 fs-8 fw-600">Rates will refresh after {{ progressWidth }} minutes </label>
<div class="progress">
    <div class="progress-bar bg-danger" role="progressbar" [ngStyle]="{'width.%': progressWidthInPercentage}" aria-valuemin="0"></div>
</div> -->
<!-- 
<div class="row mt-10 mb-20">
    <div class="col-md-12">
        <div class="card-body bg-light-grey b-radius-5">
            <div class="d-flex  justify-content-between">
                <div class="fs-17 text-black fw-600">₹ {{stepperDataCardModel?.quotationResponse?.totalBillableAmountString}}
                    <div class="fs-11 text-muted ">Includes Taxes and Charges
                        <button rippleEffect class="tooltip-icon" ngbTooltip="Handling Charges GST">
                            <span [data-feather]="'info'" class="'ml-1'"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->



                <div class="currency-panel-box mt-2" *ngIf="!isCartEmpty && isXplorerCardPurchase">
                    <div class="xplorer-breakup-wrapper">
                        <div class="table-responsive amout-breakup-bg">
                            <table class="table table-condensed table-borderless  fs-12" aria-label="Xplorer Card Details">
                                <caption class="visually-hidden">Xplorer Card Details</caption>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="background-color: #E8E8E8;">
                                        <td class="thick-line text-black fw-600" colspan="4">
                                            <div class="d-flex flex-row">
                                                <div class="breakup-forex-icon"><img src="assets/images/icon/Card details.png" alt="" /></div><span>Xplorer Card Details</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>Kit Fee : </strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.xplorerCardDetails?.kitFee }} </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td class="no-line text-right">₹ {{ quotationResponse?.xplorerCardDetails?.gst }} </td>
                                    </tr>
                                    <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                        <td class="no-line text-black fw-800 pt-10" colspan="3"> Sub Total: </td>
                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ quotationResponse?.xplorerCardDetails?.totalAmount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

<div class="currency-panel-box mt-2" *ngIf="!isCartEmpty">
<div class="amount-breakup-wrapper">
<div class="table-responsive amout-breakup-bg">
    <!-- <div>
        <table class="table table-bordered table-responsive" >
            <thead>
                <tr>
                    <th>Product</th>
                    <th>Currency</th>
                    <th>FX Amount</th>
                    <th>IBR</th>
                    <th>INR Amount</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody class="fs-10 text-black">
                <tr *ngFor="let singleTransaction of quotationCurrencyResponsesList; let i = index">
                    <td >
                        {{singleTransaction?.product}}
                    </td>
                    <td>
                        {{singleTransaction?.currencyCode}}
                    </td>
                    <td >
                        {{singleTransaction?.currencyAmount}}
                    </td>
                    <td>
                        {{singleTransaction.rateString | number :
                            '1.2-2'}}
                    </td>
                    <td>
                        {{singleTransaction.inrEquivalentAmountString}}
                    </td>
                    <td>
                        Edit
                    </td>
                </tr>
            </tbody>
        </table>
       </div>  -->

   
       <table class="table table-condensed table-borderless amout-breakup-bg fs-12">
        <caption style="display: none;">Forex Details</caption>
        <thead class="visually-hidden">
            <tr>
                <th scope="col"></th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr style="background-color: #E8E8E8;">
                <td class="thick-line text-black fw-600" colspan="4">
                    <div class="d-flex flex-row">
                        <div class="breakup-forex-icon"><img src="assets/images/icon/Forex Details.png" style="width: 25px;" alt="" /></div><span>Forex Details</span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="thick-line text-black fw-600"><strong>Amount</strong></td>
                <td class="no-line text-right">₹ {{stepperDataCardModel.quotationResponse.billableAmountString}}</td>
            </tr>
            <tr *ngIf="stepperDataCardModel.quotationResponse.finalChargesString != '0' && stepperDataCardModel.quotationResponse.finalChargesString != '0.0' && stepperDataCardModel.quotationResponse.finalChargesString != '0.00'">
                <td class="no-line"><strong>Service Charges </strong></td>
                <td class="no-line text-right">+ ₹ {{stepperDataCardModel.quotationResponse.finalChargesString}}</td>
            </tr>
            <tr>
                <td class="no-line"><strong>TCS ({{stepperDataCardModel.quotationResponse?.tcs?.tcsPercentageString}}%)</strong></td>
                <td class="no-line text-right">+ ₹ {{stepperDataCardModel.quotationResponse?.tcs?.tcsAmountString}}</td>
            </tr>
            <tr class="no-line">
                <td class="no-line"><strong>GST </strong></td>
                <td class="no-line text-right"> + ₹ {{stepperDataCardModel.quotationResponse?.gstString}}</td>
            </tr>
            <tr class="no-line" *ngIf="stepperDataCardModel.quotationResponse?.deliveryCharges">
                <td class="no-line"><strong>Delivery Charges </strong></td>
                <td class="no-line text-right"> + ₹ {{stepperDataCardModel.quotationResponse?.deliveryCharges}}</td>
            </tr>
            <tr class="no-line" *ngIf="stepperDataCardModel.quotationResponse?.redeemedPoints">
                <td class="no-line"><strong>Redeemed Points </strong></td>
                <td class="no-line text-right">- ₹ {{stepperDataCardModel.quotationResponse?.redeemedPoints}}</td>
            </tr>
            <tr class="no-line" *ngIf="stepperDataCardModel.quotationResponse?.discount">
                <td class="no-line"><strong>Coupon Code </strong></td>
                <td class="no-line text-right">- ₹ {{stepperDataCardModel.quotationResponse?.discount}}</td>
            </tr>

            <!-- <tr style="border-top:1px solid #bdbcbc">
                <td class="no-line text-black fw-800 pt-10"> Total Payable </td>
                <td class="no-line text-right text-black fw-800 pt-10">₹ {{stepperDataCardModel.quotationResponse.totalBillableAmountString}}</td>
            </tr> -->
            <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                <td class="no-line text-black fw-800 pt-10">Total Payable: </td>
                <td class="no-line text-right text-black fw-800 pt-10">₹ {{ (quotationResponse?.xplorerCardTotalBillableAmount && quotationResponse?.xplorerCardTotalBillableAmount != 0) ? quotationResponse?.xplorerCardTotalBillableAmountString : quotationResponse?.totalBillableAmountString | number }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
</div>
</div>